export default __webpack_public_path__ + "static/media/404_not_found.4861ae77.svg";